import React from "react";
import UserEdit from "src/components/Users/Edit/UserEdit";
// import ManageUserEditSection from "../components/Users/Edit/ManageUserEditSection";

const ManageUserEdit = () => {
  return <UserEdit />;
};

export default ManageUserEdit;
